import { Component, OnInit, Input, Inject, PLATFORM_ID, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { CustomDeviceDetectorService } from "../../services/custom-device-detector.service";
import { ImageService } from "../../services/image.service";
import { isPlatformServer } from "@angular/common";
import { JssStylingService } from '../../jss-styling.service';
import { JssContextService } from '../../jss-context.service';
import { ThemeService } from "../../services/theme.service";
import { Subscription } from 'rxjs';
@Component({
    selector: "app-banner4-items-center",
    templateUrl: "./banner4-items-center.component.html",
    styleUrls: ["./banner4-items-center.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Banner4ItemsCenterComponent implements OnInit, OnDestroy {
    @Input() rendering: ComponentRendering;
    public isMobile: boolean = false;
    public energySave: boolean = true;
    public energySubscription: Subscription;
    public fields: any;
    public image: { src: string; alt: string };
    data: { [key: string]: string } = {};
    items: Array<{ Content: string, Subtitle: string, Link: string }> = [];
    dynamicClass: string;
    public contextSubscription: Subscription;
    language:string;

    constructor(
        public jssStylingService: JssStylingService,
        private deviceDetector: CustomDeviceDetectorService,
        private imageService: ImageService,
        public jssContext: JssContextService, private themeService: ThemeService, private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) public readonly platformId: string
    ) {
        platformId;
    }
    _isPlatformServer: boolean = false;
    ngOnInit() {
        this._isPlatformServer = isPlatformServer(this.platformId);
        this.contextSubscription = this.jssContext.state.subscribe((newState) => {
            this.language = newState.language
          });
        this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
        this.fields = this.rendering?.fields as any;
        this.isMobile = this.deviceDetector.isMobile();
        this.createData();
        
        this.energySubscription = this.themeService.isEnegySaveModeEnabled().subscribe(energySave => {
            this.energySave = energySave;
            this.image = this.imageService.getImage(this.fields);
            this.cdr.detectChanges();
        });
        
    }

    ngOnDestroy(): void {
        if (this.contextSubscription) {
            this.contextSubscription.unsubscribe();
        }
      }

    createData() {
        this.data = {
            Content1: this.fields?.Content1?.value,
            Content2: this.fields?.Content2?.value,
            Content3: this.fields?.Content3?.value,
            Content4: this.fields?.Content4?.value,
            Subtitle1: this.fields?.Subtitle1?.value,
            Subtitle2: this.fields?.Subtitle2?.value,
            Subtitle3: this.fields?.Subtitle3?.value,
            Subtitle4: this.fields?.Subtitle4?.value,
            Link1: this.fields?.Link1?.value,
            Link2: this.fields?.Link2?.value,
            Link3: this.fields?.Link3?.value,
            Link4: this.fields?.Link4?.value,
        };
        if(this.fields?.RightImage?.value) {
            let moreData = {
                Content5: this.fields?.Content5?.value,
                Content6: this.fields?.Content6?.value,
                Subtitle5: this.fields?.Subtitle5?.value,
                Subtitle6: this.fields?.Subtitle6?.value,
                Link5: this.fields?.Link5?.value,
                Link6: this.fields?.Link6?.value,
            }

            this.data = { ...this.data, ...moreData };
        }

        const itemCount = Math.max(
            ...Object.keys(this.data)
            .map(key => parseInt(key.match(/\d+$/)?.[0] || '0', 10))
        );

        for (let i = 1; i <= itemCount; i++) {
            this.items.push({
                Content: this.data[`Content${i}`] || '',
                Subtitle: this.data[`Subtitle${i}`] || '',
                Link: this.data[`Link${i}`] || ''
            });
        }
    }
}
